//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.DrawShapes.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CanCreatePrimitives",1,0],[0,"CanMergeConnectedStrokes",1,0],[0,"DetectionSensitivity",1,0],[1,"Strokes",0,"SelectDisplayableObjectList",0]],[[["mergeTolerance"],"SetMergeTolerance",{},1,0]],[]];
SPLM.Features.DrawShapes.CurveFromStrokeData = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.DrawShapes.CurveFromStrokeData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.DrawShapes.CurveFromStrokeData.DetectionSensitivityOption = Object.freeze({
    "Low" : "Low", "Standard" : "Standard", "High" : "High"});

export default SPLM;